import { PurchaseRequester } from './purchase-requester';

export interface PurchaseRequestFile {
  name: string;
  url: string;
  branchId: string;
  /** Apelido da filial, para o tooltip do card. */
  branchName?: string;
  /** Logradouro e complemento. */
  branchStreet?: string;
  /** Cidade/UF · CEP. */
  branchCity?: string;
}

export enum PurchaseItemStatus {
  PENDING = 'Pendente',
  APPROVED = 'Aceita',
  DECLINED = 'Recusado',
  REMOVED = 'Removido'
}

export interface PurchaseRequest {
  id: string;
  requestedAt: Date;
  requester: PurchaseRequester;
  status: PurchaseItemStatus;
  file: PurchaseRequestFile;
}
